import { fristFuerPrioritaet } from '../tickets/frist';

export interface TicketVorlage {
  titel: string;
  beschreibung: string;
  objekt_id?: string;
  mieter_id?: string;
  kategorie_id?: string;
  prioritaet: string;
  faellig_am?: string | null;
  einheit_id?: string | null;
  quelle_email_id?: string | null;
  absender_typ?: string | null;
  unterkategorie_id?: string | null;
  erkannte_aufgabe?: string | null;
  naechster_schritt?: string | null;
  bearbeiter_vorschlag_id?: string | null;
  bearbeiter_vorschlag_typ?: 'profile' | 'team' | null;
  dienstleister_vorschlag_id?: string | null;
  ki_confidence?: number | null;
  ist_rechtlich_sensibel?: boolean;
  // #489 Vorgang (nur gesetzt, wenn ein Vorgang gestartet wird)
  vorgangsart_id?: string | null;
  vorgang_angaben?: Record<string, unknown> | null;
  wiedervorlage_am?: string | null;
  zustaendig_id?: string | null;
  zustaendig_typ?: 'mitarbeiter' | 'team' | null;
}

interface AnalyseInput {
  erkannte_aufgabe?: string | null;
  zusammenfassung?: string | null;
  objekt_id?: string | null;
  mieter_id?: string | null;
  einheit_id?: string | null;
  email_id?: string | null;
  kategorie_id?: string | null;
  prioritaet?: string | null;
  ist_notfall?: boolean | null;
  absender_typ?: string | null;
  naechster_schritt?: string | null;
  bearbeiter_vorschlag_id?: string | null;
  bearbeiter_vorschlag_typ?: 'profile' | 'team' | null;
  dienstleister_vorschlag_id?: string | null;
  confidence?: number | null;
  ist_rechtlich_sensibel?: boolean;
}
interface EmailInput {
  betreff?: string | null;
  plainText?: string | null;
  objekt_id?: string | null;
  mieter_id?: string | null;
  absender?: string | null;
  datum?: string | null;
}

const PRIOS = ['niedrig', 'mittel', 'hoch', 'kritisch'];

export function analyseZuTicketVorlage(
  analyse: AnalyseInput,
  email: EmailInput,
  vorschlag: { name: string; telefon: string | null } | null,
  opts?: { kategorien?: { id: string; parent_id: string | null }[]; schwelle?: number; heute?: Date },
): TicketVorlage {
  const titel = (analyse.erkannte_aufgabe || '').trim() || (email.betreff || '').trim() || 'Ticket aus E-Mail';
  // Analyse-Vokabular nutzt 'dringend' für die höchste Stufe; Ticket-Vokabular nutzt 'kritisch'.
  const prioRaw = analyse.ist_notfall ? 'kritisch' : (analyse.prioritaet === 'dringend' ? 'kritisch' : (analyse.prioritaet || 'mittel'));
  const prioritaet = PRIOS.includes(prioRaw) ? prioRaw : 'mittel';
  const objekt_id = analyse.objekt_id || email.objekt_id || undefined;
  const mieter_id = analyse.mieter_id || email.mieter_id || undefined;

  const conf = analyse.confidence ?? 0;
  const schwelle = opts?.schwelle ?? 0.8;
  const kat = opts?.kategorien?.find((k) => k.id === analyse.kategorie_id);
  const hatParent = !!kat?.parent_id;
  const kategorie_id = hatParent ? kat!.parent_id! : (analyse.kategorie_id || undefined);
  const unterkategorie_id = hatParent ? analyse.kategorie_id ?? null : null;

  const teile: string[] = [];
  if (analyse.zusammenfassung && analyse.zusammenfassung.trim()) teile.push(analyse.zusammenfassung.trim());
  if (email.absender || email.datum) teile.push(`— aus E-Mail von ${email.absender || 'unbekannt'}${email.datum ? ` (${email.datum})` : ''} —`);
  if (vorschlag) teile.push(`KI-Vorschlag Dienstleister: ${vorschlag.name}${vorschlag.telefon ? ` · ${vorschlag.telefon}` : ''}`);
  if (email.plainText && email.plainText.trim()) teile.push(email.plainText.trim().substring(0, 800));
  const beschreibung = teile.join('\n\n');

  return {
    titel,
    beschreibung,
    objekt_id,
    mieter_id,
    kategorie_id,
    prioritaet,
    // Automatische Bearbeitungsfrist nach Priorität (Werktage, lib/tickets/frist.ts).
    faellig_am: fristFuerPrioritaet(prioritaet, opts?.heute),
    einheit_id: analyse.einheit_id ?? null,
    quelle_email_id: analyse.email_id ?? null,
    absender_typ: analyse.absender_typ ?? null,
    unterkategorie_id,
    erkannte_aufgabe: analyse.erkannte_aufgabe ?? null,
    naechster_schritt: analyse.naechster_schritt ?? null,
    bearbeiter_vorschlag_id: conf >= schwelle ? analyse.bearbeiter_vorschlag_id ?? null : null,
    bearbeiter_vorschlag_typ: conf >= schwelle ? analyse.bearbeiter_vorschlag_typ ?? null : null,
    dienstleister_vorschlag_id: analyse.dienstleister_vorschlag_id ?? null,
    ki_confidence: analyse.confidence ?? null,
    ist_rechtlich_sensibel: analyse.ist_rechtlich_sensibel ?? false,
  };
}
